import { atom } from "jotai";

export const importFromTextDialogAtom = atom(false);
export const metadataEditorDialogAtom = atom(false);
export const settingsDialogAtom = atom(false);
export const settingsTabAtom = atom("common");
export const latencyTestDialogAtom = atom(false);
export const splitWordDialogAtom = atom(false);
export const replaceWordDialogAtom = atom(false);
export const timeShiftDialogAtom = atom(false);
export const distributeRomanizationDialogAtom = atom(false);
export const confirmDialogAtom = atom<{
	open: boolean;
	title: string;
	description: string;
	onConfirm?: () => void;
	/** When true, only an OK button is shown (for alerts). */
	alertOnly?: boolean;
}>({
	open: false,
	title: "",
	description: "",
});
export const historyRestoreDialogAtom = atom(false);
export const importFromLRCLIBDialogAtom = atom(false);
export const importFromAppleMusicDialogAtom = atom(false);
export const uploadToTtmlDbDialogAtom = atom(false);
